import { filter } from 'lodash';
const filterServiceTypeOptions = function () {
  let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let search = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  if (!search) {
    return options;
  }
  const lowerSearch = search.toLowerCase();
  const filtered = options.reduce(function (acc) {
    let curr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const currentValue = curr.label || curr.name;
    if (currentValue.toLowerCase().includes(lowerSearch)) {
      return [...acc, curr];
    }
    const children = filter(curr.children, function () {
      let child = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      const currentchildValue = child.label || child.name;
      return currentchildValue.toLowerCase().includes(lowerSearch);
    });
    if (children.length > 0) {
      return [...acc, {
        ...curr,
        children
      }];
    }
    return acc;
  }, []);
  return filtered;
};
export default filterServiceTypeOptions;
//# sourceMappingURL=filterServiceTypeOptions.js.map